<script setup="">
import { ref, computed } from 'vue'

const props = defineProps({
  modelValue: {},
  reach: {}

})
const emit = defineEmits([
  'update:modelValue'
])

const vModel = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    emit('update:modelValue', val)
  }
})
</script>
<template>
  <div class="socials-modal" v-if="reach">
    <div class="socials-modal-logo" v-html="reach?.logo"></div>
    <div class="socials-modal-title">{{ reach?.title }}</div>
    <div class="socials-modal-reach">
      <div class="socials-modal-phone">
        <div>{{ reach?.phoneTitle }}</div>
        <a class="socials-modal-phone-link" :href="`tel:${reach?.phone}`" target="_blank">{{ reach?.phone }}</a>
      </div>
      <div class="socials-modal-social">
        <a v-for="s in reach?.socials" class="socials-modal-btn" :href="s?.link" target="_blank">
          <div v-html="s?.img"></div>
          <div class="socials-modal-btn-name">{{ s?.name }}</div>
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M6.70711 5.29289C7.09763 5.68342 7.09763 6.31658 6.70711 6.70711L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976315 11.3166 -0.0976314 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.097631 1.31658 -0.097631 0.683417 0.292893 0.292893C0.683417 -0.0976314 1.31658 -0.0976313 1.70711 0.292893L6.70711 5.29289Z" fill="white"/>
            </svg>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.socials-modal {
  max-width: 534px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  color: $white;

  &-logo {
    display: flex;
    justify-content: center;
  }

  &-title {
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    line-height: 36px;
  }
  &-reach {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;

    @include phone {
      display: flex;
      flex-direction: column-reverse;
    }
  }

  &-phone {
    border-radius: 12px;
    background: $color_dark-80;
    display: flex;
    padding: 32px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 32px;
    text-align: center;
    font-size: 22px;
    font-weight: 400;
    line-height: 22px;

    &-link {
      font-size: 24px;
      font-weight: 700;
      line-height: 24px;
    }
  }

  &-social {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &-btn {
    display: flex;
    border-radius: 12px;
    background: $color_orange-50;
    padding: 10px 12px;
    gap: 12px;
    align-items: center;
    justify-content: space-between;

    &-name {
      padding-left: 10px;
      flex: 1;
      font-size: 20px;
      font-weight: 700;
      line-height: 20px;
    }
  }
}
</style>